<template>
  <div id="app" :class="{ hidePhoneIsdDropDOwn: isd_drop_down === true }">
    <div class="app-container">
      <content-description
        class="px-5"
        v-if="showContent"
      ></content-description>
      <div class="w-sm-100 w-100 bg-white p-0 height-100">
        <div class="paading-top">
          <header-title
            v-if="showContent && !isShellApp"
            class="w-50 w-sm-100 m-md-auto mobile-view"
            :title="headerTitle.title"
            :show="headerTitle.showBackIcon"
          >
          </header-title>

          <notification
            v-if="message.msg"
            :notification="message"
          ></notification>
          <router-view></router-view>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading.isLoading"
      :can-cancel="loading.canCancel"
      :is-full-page="loading.fullPage"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { EventBus } from "./events";
import { mapState } from "vuex";
import HeaderTitle from "./components/HeaderTitle.vue";
import Notification from "./components/Notification.vue";
import ContentDescription from "./components/Content";

export default {

  data() {
    return {
      spin_visible: 0,
      loading: {
        isLoading: false,
        canCancel: false,
        fullPage: true,
      },
      isd_drop_down: false,
      showContent: false,
    };
  },
  computed: {
    ...mapState("projects", {
      message: "notificationMsg",
      headerTitle: "headerTitle",
      unleashValue: "unleashEnalbed",
    }),
  },

  methods: {
    showSpin() {
      this.spin_visible++;
    },
    hideSpin() {
      if (this.spin_visible > 0) this.spin_visible--;
    },
    isdDropDown(value) {
      if (!value) this.isd_drop_down = true;
      else this.isd_drop_down = false;
    },
    hideIsdDropDown() {
      if (this.isd_drop_down) this.isd_drop_down = false;
    },
    getHeaderTitle() {
      return this.headerTitle ? this.headerTitle : this.$route.meta.title;
    },
    SendShellAppEvent(){
      /**
       *  share Auth tokens with superApp, So later the SuperApp can use them to fetch logged in user information.
      */
      let urlData = window.location.search;
      const isAccessTokenPresentInURL =
      urlData && urlData.includes("access_token");
      if (isAccessTokenPresentInURL) {
        let tokens = new URLSearchParams(urlData);
        let TokenJson = Object.fromEntries(tokens.entries())
        this.sendPostMessageToShellApp('AUTH_DATA', {
          tokens: TokenJson
        })
      }
    }
  },

  created() {
    EventBus.$on("show_spin", this.showSpin);
    EventBus.$on("hide_spin", this.hideSpin);
    EventBus.$on("isd_drop_down", this.isdDropDown);
    EventBus.$on("showContent", () => {
      this.showContent = true;
    });
  },

  beforeCreate() {
    /**
     * This is to hard reload the page, once the cookies is cleared. This is   required to make the new changes visible.
     */

    /* clearing cookies */
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    /**
     * HARD RELOAD:
     */
    const checkForHardReload = localStorage.getItem("isHardLoadingEnabled");
    if (cookies.length && !checkForHardReload) {
      localStorage.setItem("isHardLoadingEnabled", true);
      location.reload(true);
    }
  },

  async mounted() {
    /**
     * This we can use to enable unleash for new feature
     */
    // const response = await services.getUnleaseValue('');
    // localStorage.setItem("isEnable", response.data.isEnabled);
    // this.setValue(response.data.isEnabled);
    EventBus.$emit("captureEvents", "accounts_customer:sign_in_page_load");
    this.SendShellAppEvent();
  },
  components: {
    Loading,
    HeaderTitle,
    Notification,
    ContentDescription,
  },

  watch: {
    spin_visible: function (val) {
      this.loading.isLoading = val > 0;
    },
  },
};
</script>

<style>
.showContent {
  display: none;
}
@media (max-width: 786px) {
  .showContent {
    display: block;
  }
  .mobile-view {
    margin-bottom: 16px;
  }
}
.app-container {
  display: flex;
}
.input-2Z0b:focus {
  outline: none;
  border: 1px solid #e5e5e5;
}
.colorOnSurface100-2ozW {
  color: #666666;
}
.iti input {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1a1a1a;
}

.focusHighlightLabelPosition-3Qn3 {
  z-index: 1;
  position: absolute;
  top: -6px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
.paading-top {
  padding-top: 3rem;
}
@media (max-width: 786px) {
  .paading-top {
    padding-top: 0;
  }
  .mobile {
    padding: 0 16px;
  }
}
</style>
